import { AlertController, Platform } from 'ionic-angular';
import { Injectable } from '@angular/core';
import { TextServiceProvider } from '../text-service/text-service';

@Injectable()
export class AlertServiceProvider {
  private errorAlert = {
    title: this.textService.get('defaultErrorTitle'),
    subTitle: this.textService.get('defaultErrorText'),
    buttons: [this.textService.get('defaultErrorButton')],
  };
  private infoAlert = {
    title: this.textService.get('defaultInfoTitle'),
    subTitle: '',
    buttons: [this.textService.get('defaultInfoButton')],
  };

  constructor(private alertCtrl: AlertController, private plt: Platform, public textService: TextServiceProvider) {}

  public showErrorAlert(content?, title?, buttons?): Promise<any> {
    const localAlert = this.errorAlert;
    localAlert.subTitle = content ? content : localAlert.subTitle;
    localAlert.title = title ? title : localAlert.title;
    localAlert.buttons = buttons ? buttons : localAlert.buttons;
    return this.alertCtrl.create(localAlert).present();
  }

  public showInfoAlert(content?, title?): Promise<any> {
    let localAlert = this.infoAlert;
    localAlert.subTitle = content;
    localAlert.title = title ? title : localAlert.title;
    return this.alertCtrl.create(localAlert).present();
  }

  public showNoConnAlert(onDidDismiss?): Promise<any> {
    let alert = this.alertCtrl.create({
      title: this.textService.get('networkErrorTitle'),
      message: this.textService.get('networkErrorText'),
      buttons: [this.textService.get('networkErrorButton')],
    });

    if (onDidDismiss) {
      alert.onDidDismiss(() => {
        onDidDismiss();
      });
    }

    return alert.present();
  }

  public showServiceDownError(): Promise<any> {
    return this.showErrorAlert(this.textService.get('serviceNotReachable'), this.textService.get('serviceNotReachableTitle'));
  }

  public showServiceInternalError(): Promise<any> {
    return this.showErrorAlert(
      this.textService.get('serviceInternalError') || 'Wystąpił błąd wewnętrzny',
      this.textService.get('serviceInternalErrorTitle') || 'Błąd',
    );
  }

  public showUnexpectedError(): Promise<any> {
    return this.showErrorAlert(
      this.textService.get('unexpectedError') || 'Wystąpił nieoczekiwany błąd',
      this.textService.get('serviceInternalErrorTitle') || 'Błąd',
    );
  }

  public showCodeFlowLoginError(): Promise<any> {
    return this.showErrorAlert(
      this.textService.get('loginCodeFlowText') || 'Nie udało się poprawnie przeprowadzić procesu logowania',
      this.textService.get('loginErrorTitle') || 'Błąd logowania',
    );
  }

  public showUpdateAlert(onDidAction: Function): Promise<any> {
    const alert = this.alertCtrl.create({
      enableBackdropDismiss: false,
      title: this.textService.get('newerVersionTitle'),
      message: this.textService.get('newerVersionText'),
      buttons: [
        {
          text: this.textService.get('newerVersionButton'),
          handler: () => onDidAction(),
        },
      ],
    });

    return alert.present();
  }

  public showConfirmApplicationClosing(): Promise<any> {
    const alert = this.alertCtrl.create({
      title: this.textService.get('appEnd') || 'Zakończ',
      message: this.textService.get('appAreYouSure') || 'Czy na pewno chcesz zamknąć aplikację?',
      buttons: [
        {
          text: this.textService.get('appNo') || 'Nie',
          role: 'cancel',
        },
        {
          text: this.textService.get('appYes') || 'Tak',
          handler: () => this.plt.exitApp(),
        },
      ],
    });

    return alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/modules/core/services/alert-service/alert-service.ts